<template>
    <div style="text-align: center;">
        CtbUser
    </div>
</template>

<script>
    export default {
        name: "CtbUser",
    };
</script>

<style>

</style>